import {GetObjectCommand, S3Client} from "@aws-sdk/client-s3";
import {getSignedUrl} from "@aws-sdk/s3-request-presigner";

const s3 = new S3Client({
  region: "eu-north-1",
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  },
});

export const S3SignedUrl = async(bucket, key) => {
  try {
    const command = new GetObjectCommand({
      Bucket: bucket,
      Key: key,
      // ResponseContentDisposition: "inline",
      // ResponseContentType: contentType,
    });
    const signedUrl = await getSignedUrl(s3, command, {expiresIn: 60 * 60});
    return signedUrl;
  } catch (error) {
    console.error("Error generating signed URL: ", error);
    throw error;
  }
}
